<template>
  <v-layout row wrap class="mt-1">
    <v-flex xs12 md7>
      <user-card v-show="!usersLoading" v-for="user in users" :key="user.id" :user-name="user.name" :user-document="user.document" :user-email="user.email" :user-role="user.role" :user-status="user.active" :user-id="user.id" @getUsers="getUsers()" />
      <h2 v-if="usersLoading" class="text-xs-center font-weight-light">CARREGANDO USUÁRIOS, AGUARDE!</h2>
    </v-flex>
    <v-flex xs12 md5>
      <v-form class="user-form px-3 elevation-2" ref="userForm" v-model="validForm" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12>
            <v-alert v-model="alert.status" dismissible :type="alert.type">{{ alert.message }}</v-alert>
            <h3 class="mb-2">CADASTRAR NOVA UNIDADE AO SISTEMA.</h3>
            <hr>
          </v-flex>
          <v-flex xs12 class="py-0">
            <v-text-field v-model="userData.name" :counter="46" label="NOME, EX: Antônio, Cristina..." :rules="nameRules" required box/>
          </v-flex>
          <v-flex xs12 class="py-0">
            <v-text-field v-model="userData.email" :counter="255" label="E-MAIL VALIDO" :rules="emailRules" required box/>
          </v-flex>
          <v-flex xs12 class="py-0">
            <v-text-field v-model="userData.document" :counter="11" label="CPF SEM PONTUAÇÃO" :rules="documentRules" required box/>
          </v-flex>
          <v-flex xs12 class="py-0">
            <v-text-field v-model="userData.password" :counter="40" label="SENHA TEMPORÁRIA" :rules="passwordRules" required box/>
          </v-flex>
          <v-flex xs12 class="py-0">
            <v-select box color="black" v-model="userData.role" hint="PERMISSÕES DE USUÁRIO" :items="roles" item-text="name" item-value="role" persistent-hint return-object single-line required></v-select>
          </v-flex>
          <v-flex xs6 class="mt-0 pt-0">
            <v-btn class="ma-0" color="success" style="width: 100%;" @click="createUser()" outline>CADASTRAR</v-btn>
          </v-flex>
          <v-flex xs6 class="mt-0 pt-0">
            <v-btn class="ma-0" color="error" style="width: 100%;" @click="clearForm()" outline>LIMPAR</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import UserCard from '../../components/UserCard'

export default {
  name: 'users',
  components: { UserCard },
  data() {
    return {
      users: [],
      validForm: true,
      usersLoading: true,
      userData: {
        name: '', email: '', document: '', role: {role: 'viewer', name: 'VISUALIZADOR'}, password: ''
      },
      roles: [
        { role: 'admin', name: 'ADMINISTRADOR' },
        { role: 'viewer', name: 'VISUALIZADOR' },
      ],
      nameRules: [
        v => !!v || 'NOME REQUERIDO!',
        v => (v && v.length >= 10) || 'NOME NÃO PODE TER MENOS DE 10 CARACTERES!',
        v => (v && v.length <= 46) || 'NOME NÃO PODE TER MAIS DE 46 CARACTERES!',
      ],
      emailRules: [
        v => !!v || 'E-MAIL REQUERIDO!',
        v => (v && v.length >= 6) || 'E-MAIL NÃO PODE TER MENOS DE 06 CARACTERES!',
        v => (v && v.length <= 255) || 'E-MAIL NÃO PODE TER MAIS DE 255 CARACTERES!',
      ],
      documentRules: [
        v => !!v || 'CPF REQUERIDO!',
        v => (v && v.length == 11) || 'CPF DEVE CONTER EXATAMENTE 11 CARACTERES!',
      ],
      passwordRules: [
        v => !!v || 'SENHA REQUERIDO!',
        v => (v && v.length >= 6) || 'SENHA NÃO PODE TER MENOS DE 06 CARACTERES!',
        v => (v && v.length <= 40) || 'SENHA NÃO PODE TER MAIS DE 40 CARACTERES!',
      ],
      alert: {
        message: 'BASE ALERT',
        type: 'error',
        status: false
      },
    }
  },
  methods: {
    getUsers() {
      this.$http.get('users').then(data => {
        this.users = data.data
        this.usersLoading = false
      }).catch(err => {
        this.alert.message = err
        this.alert.type = 'error'
        this.alert.status = true
      })
    },
    createUser() {
      if (this.$refs.userForm.validate()) {
        this.$http.post('users', {
          name: this.userData.name,
          email: this.userData.email,
          document: this.userData.document,
          role: this.userData.role.role,
          password: this.userData.password,
        }).then(data => {
          this.alert.message = 'USUÁRIO CADASTRADO!'
          this.alert.type = 'success'
          this.alert.status = true
          this.clearForm()
          this.getUsers()
        }).catch(err => {
          this.alert.message = err
          this.alert.type = 'error'
          this.alert.status = true
        })
      } else {
        this.alert.message = 'CAMPOS INVALIDOS!'
        this.alert.type = 'warning'
        this.alert.status = true
      }
    },
    clearForm() {
      this.$refs.userForm.reset()
      this.userData.role = { role: 'viewer', name: 'VISUALIZADOR' }
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    }
  },
  created() {
    this.getUsers()
  }
}
</script>

<style scoped>
  .user-form {
    background-color: #fff;
  }
</style>
